const lastReloadKey = 'staleChunkReloadAt';
// Long enough to cover a reload that goes through the Auth0 redirect on a slow connection
const reloadWindowMs = 60_000;

const staleChunkErrors = new WeakSet<object>();

// A deploy removes the previous build's files, so a tab opened before it cannot load any
// page or modal it has not loaded yet. Vite reports each such failure here before the
// import rejects, which tells them apart from other errors without reading browser-specific
// messages. The error is left to reach the route's error element: by then the router has
// moved to the page the user was going to, so a reload lands there.
export const markStaleChunkErrors = () => {
  window.addEventListener('vite:preloadError', (event) => {
    staleChunkErrors.add(event.payload);
  });
};

const reloadedRecently = () =>
  Date.now() - Number(sessionStorage.getItem(lastReloadKey) ?? 0) < reloadWindowMs;

// A second failure soon after a reload is not a stale tab but a file that cannot be loaded
// at all, so it shows the error instead of reloading again and again.
export const canReloadForStaleChunk = (error: unknown) =>
  error instanceof Object && staleChunkErrors.has(error) && !reloadedRecently();

export const reloadForStaleChunk = () => {
  if (reloadedRecently()) {
    return;
  }
  sessionStorage.setItem(lastReloadKey, String(Date.now()));
  window.location.reload();
};
